<app-header></app-header>
<div class="container">
    <div class="guest-app-container width100" fxLayout="row">
        <div class="guest-app-child" fxLayout="column" fxLayoutGap="2%">
            <div fxLayout="row">
                <button class="online-button">
                    <ul class="custom-list">
                        <li>Performance Management Software & SOP Adherence for Hotels
                        </li>
                    </ul>
                </button>
            </div>
            <h2 class="guest-app-child-heading">Empower Your Team with Performance Tracking Software</h2>
            <div *ngIf="mobile" style="align-items: center;">
                <img class="image" src="/assets/images/Performance Management Software.png" />
            </div>
            <div class="guest-app-child-text">Simplify hotel workflows, boost staff accountability, and ensure SOP
                compliance with the GoFriday’s Performance Management system -designed to enhance efficiency and deliver
                exceptional guest satisfaction.
            </div>
            <div class="buttons">
                <button class="book-btn" (click)="openCalendlyPopup()">
                    Book A Demo Today
                </button>
                <button class="demo-link" (click)="selectTrial()">
                    Talk to Us
                    <iconify-icon icon="material-symbols:arrow-right-alt" class="arrow-icon"></iconify-icon>
                </button>
            </div>
        </div>
        <div class="image-container" *ngIf="!mobile">
            <img class="image" src="/assets/images/Performance Management Software.png" />
        </div>
    </div>
    <div class="info-container1 width100" fxLayout="column" fxLayoutAlign="center center">
        <div fxLayout="column" class="why-choose-content-container">
            <h3 class="guest-app-child-heading2" style="padding-bottom: 5%;">
                Key Features of GoFriday Performance Management Software
            </h3>
            <div fxLayout="row" fxLayoutGap="4%" class="why-choose-content">
                <div class="member-div" fxLayout="column" fxLayoutGap="1%" fxLayoutAlign="center center">
                    <img class="choose-image" src="/assets/images/Automated Task Scheduling.png" alt="" />
                    <h3 class="why-choose-content-head">
                        Real-Time Task Tracking
                    </h3>
                    <div class="why-choose-text">Track tasks across departments in real time to ensure timely
                        completion.
                    </div>
                </div>
                <div fxLayout="column" fxLayoutGap="1%" class="member-div">
                    <img class="choose-image" src="/assets/images/SLA Compliance Simplified.png" alt="" />
                    <h3 class="why-choose-content-head">
                        SLA Compliance Simplified
                    </h3>
                    <div class="why-choose-text">Automated alerts help monitor SLAs and maintain service quality</div>
                </div>
                <div fxLayout="column" fxLayoutGap="1%" class="member-div">
                    <img class="choose-image" src="/assets/images/SOP Adherence.png" alt="" />
                    <h3 class="why-choose-content-head">
                        SOP Adherence with Custom Checklists
                    </h3>
                    <div class="why-choose-text">Custom checklists ensure standardized, step-by-step SOP compliance.
                    </div>
                </div>
                <div fxLayout="column" fxLayoutGap="1%" class="member-div">
                    <img class="choose-image" src="/assets/images/Root Cause Analysis.png" alt="" />
                    <h3 class="why-choose-content-head">
                        Performance Metrics and Data Analytics
                    </h3>
                    <div class="why-choose-text">Gain insights to improve efficiency and reward top performers.
                    </div>
                </div>
                <div fxLayout="column" fxLayoutGap="1%" class="member-div">
                    <img class="choose-image" src="/assets/images/Multichannel Collection.png" alt="" />
                    <h3 class="why-choose-content-head">
                        Staff Accountability and Transparency
                    </h3>
                    <div class="why-choose-text">Assign tasks clearly and track progress in real-time for transparency.
                    </div>
                </div>
            </div>
        </div>
        <h2 class="guest-app-child-heading2">
            Benefits
        </h2>
        <div class="benefits-container">
            <div class="benefit" fxLayout="column" fxLayoutAlign="center center">
                <div class="benefit-number">01</div>
                <h3>Assign Tasks Effectively</h3>
                <p>Provide detailed instructions, deadlines, and priorities to keep staff on track.</p>
            </div>
            <mat-divider *ngIf="!mobile"></mat-divider>
            <div class="benefit" fxLayout="column" fxLayoutAlign="center center">
                <div class="benefit-number">02</div>
                <h3>Monitor Progress and Performance in Real Time</h3>
                <p>Use automated dashboards to stay updated without manual follow-ups.
                </p>
            </div>
            <mat-divider *ngIf="!mobile"></mat-divider>
            <div class="benefit" fxLayout="column" fxLayoutAlign="center center">
                <div class="benefit-number">03</div>
                <h3>Evaluate SLA and SOP Compliance with Reports</h3>
                <p>Access reports to identify and address gaps in compliance effectively.</p>
            </div>
            <mat-divider *ngIf="!mobile"></mat-divider>
            <div class="benefit" fxLayout="column" fxLayoutAlign="center center">
                <div class="benefit-number">04</div>
                <h3>Optimize Hotel Workflows</h3>
                <p>Streamline operations with insights that boost efficiency and guest focus.</p>
            </div>
        </div>
    </div>

    <div class="info-container3 width100" fxLayout="column" fxLayoutAlign="center center">
        <div style="width: 100%;">
            <h2 class="guest-app-child-heading2" style="padding: 0% 5% 5% 16%;" *ngIf="!mobile">
                Why Choose GoFriday for Performance Management?
            </h2>
            <div class="features-section2" fxLayout="column" *ngIf="!mobile">
                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5%">
                    <div class="features-image-container-left">
                        <img class="features-images" src="assets/images/Performance Management Works.png">
                    </div>
                    <div fxLayout="column" fxFlex="44%" fxLayoutGap="2%">
                        <div fxLayout="column" fxLayoutGap="1%">
                            <div class="features-sub-heading">
                                Boost Guest Satisfaction
                            </div>
                            <div class="features-sub-text">
                                Achieve operational excellence with strict SOP adherence.
                            </div>
                        </div>
                        <div fxLayout="column" fxLayoutGap="1%">
                            <div class="features-sub-heading">
                                Enhance Efficiency
                            </div>
                            <div class="features-sub-text">
                                Simplify task tracking and management with real-time monitoring
                            </div>
                        </div>
                        <div fxLayout="column" fxLayoutGap="1%">
                            <div class="features-sub-heading">
                                Achieve Compliance with Ease
                            </div>
                            <div class="features-sub-text">
                                Manage SLA and SOP requirements effectively, meeting all service standards.
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div fxLayout="column" fxLayoutAlign="center center" *ngIf="mobile">
                <div fxLayout="column" fxLayoutAlign="space-between center">
                    <div fxLayout="column" fxLayoutGap="2%" style="padding: 4% 5% 3% 5%;">
                        <h2 class="features-heading">
                            Why Choose GoFriday for Performance Management?
                        </h2>
                    </div>
                    <div class="features-image-container-left">
                        <img class="features-images" src="assets/mobile-images/Performance Management Works.png">
                    </div>
                    <div fxLayout="column" fxLayoutGap="2%" style="padding: 15% 5% 5% 5%;">
                        <div class="features-sub-heading">
                            Boost Guest Satisfaction
                        </div>
                        <div class="features-sub-text">
                            Achieve operational excellence with strict SOP adherence.
                        </div>
                    </div>
                    <div fxLayout="column" fxLayoutGap="2%" style="padding: 2% 5% 5% 5%;">
                        <div class="features-sub-heading">
                            Enhance Efficiency
                        </div>
                        <div class="features-sub-text">
                            Simplify task tracking and management with real-time monitoring.
                        </div>
                    </div>
                    <div fxLayout="column" fxLayoutGap="2%" style="padding: 2% 5% 5% 5%;">
                        <div class="features-sub-heading">
                            Achieve Compliance with Ease
                        </div>
                        <div class="features-sub-text">
                            Manage SLA and SOP requirements effectively, meeting all service standards.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div fxLayout="row" class="info-container4 width100" fxLayoutAlign="space-between center" *ngIf="!mobile">
        <div class="contact-image" fxFlex="45%">
            <img class="bottom-image" src="assets/images/Performance.png">
        </div>
        <div fxFlex="45%" fxLayout="column" fxLayoutGap="1%">
            <div>
                <h2 class="header">Transform Your Hotel <br> Operations Today</h2>
            </div>
            <div class="info-text">
                Discover how the GoFriday Task App can revolutionize your hotel’s performance management and ensure SOP
                compliance.
            </div>
            <div style="margin-top: 3%;">
                <button class="book-btn" (click)="openCalendlyPopup()">
                    Book A Demo Today
                </button>
            </div>
        </div>
    </div>

    <div fxLayout="column" class="info-container4 width100" fxLayoutAlign="center center" *ngIf="mobile">
        <div>
            <div>
                <h2 class="header">Transform Your Hotel Operations Today</h2>
            </div>
            <div class="contact-image" *ngIf="mobile" style="text-align: center;">
                <img src="assets/mobile-images/Performance.png">
            </div>
            <div class="info-text">
                Discover how the GoFriday Task App can revolutionize your hotel’s performance management and ensure SOP
                compliance.
            </div>
            <div style="margin-top: 3%;text-align: center;">
                <button class="book-btn" (click)="openCalendlyPopup()">
                    Book A Demo Today
                </button>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>